export default __webpack_public_path__ + "static/ecosystem-5b6f7a36a5e1b504c30bb5a25c106e64.png";